import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const onboarding = createSlice({
  name,
  initialState: {
    playlistPopperOpen: false,
    skillbiteCSVPopperOpen: false,
    myLearningBadge: false,
    myLearningFeedback: false,
    homeEnterprisePopperOpen: false,
    checklist: false,
    checklistItems: {
      quiz: false,
      skillBite: false,
      mcoach: false,
      playlist: false
    },
    onboarding: {}
  },
  reducers: {
    setOnboardingProfile: (state, { payload }) => {
      state.playlistPopperOpen = payload.onboarding.playlists.show && !payload.onboarding.playlists.onboarded
      state.skillbiteCSVPopperOpen = payload.onboarding.skillbiteCSV?.show && !payload.onboarding.skillbiteCSV?.onboarded
      state.onboarding = {
        ...payload
      }
      state.homeEnterprisePopperOpen = payload.onboarding.homeEnterprise.show && !payload.onboarding.homeEnterprise.onboarded
      state.myLearningBadge = payload.onboarding.myLearning.show && !payload.onboarding.myLearning.onboarded
      state.myLearningFeedback = payload.onboarding.myLearningFeedback.show && !payload.onboarding.myLearningFeedback.onboarded
      state.checklist = payload.onboarding.checklist.show && !payload.onboarding.checklist.onboarded
      console.log('payload.onboarding.checklist', payload.onboarding.checklist)
      state.checklistItems = {
        quiz: payload.onboarding.checklist.items?.quiz || false,
        skillBite: payload.onboarding.checklist.items?.skillBite || false,
        mcoach: payload.onboarding.checklist.items?.mcoach || false,
        playlist: payload.onboarding.checklist.items?.playlist || false
      }
    },
    openPlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    closePlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    closeSkillbiteCSVPopper: (state) => {
      state.skillbiteCSVPopperOpen = false
    },
    closeHomeEnterprisePopper: (state) => {
      state.onboarding.onboarding.homeEnterprise.show = false
      state.homeEnterprisePopperOpen = false
    },
    removeMyLearningBadge: (state) => {
      state.myLearningBadge = false
    },
    dismissMyLearningFeedback: (state) => {
      state.myLearningFeedback = false
    },
    handleChecklistEvent: (state, { payload }) => {
      switch (payload?.type) {
        case 'dismissChecklist':
          if (state.onboarding?.checklist?.viewCount >= 2) {
            state.checklist = false
          }
          break
        case 'onboardedChecklist':
          if (state.onboarding?.checklist) {
            state.onboarding.checklist.onboarded = true
            state.checklist = false
          }
          break
        default:
          break
      }
    },
    handleChecklistItemEvent: (state, { payload }) => {
      const { items } = payload.onboarding.checklist
      state.checklistItems = items
    }
  }
})

export const { setOnboardingProfile, openPlaylistPopper, closeHomeEnterprisePopper, closePlaylistPopper, closeSkillbiteCSVPopper, removeMyLearningBadge, dismissMyLearningFeedback, handleChecklistEvent, handleChecklistItemEvent } = onboarding.actions

export default onboarding.reducer
